// src/components/profile-edit.component.tsx
import React, { useState } from 'react';
import { Form, Button, Row, Col } from 'react-bootstrap';
import { iProfile } from '../interfaces/profile.interface';

interface ProfileEditProps {
    profile: iProfile;
    onSave: (updatedProfile: iProfile) => void;
    onCancel: () => void;
}

const ProfileEdit: React.FC<ProfileEditProps> = ({ profile, onSave, onCancel }) => {
    const [formData, setFormData] = useState<iProfile>({ ...profile });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        onSave(formData);
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row className="mb-3">
                <Col xs={12}>
                    <h4 className="greenColour">Edit Profile</h4>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={6}>
                    <Form.Group controlId="firstName">
                        <Form.Label>First Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group controlId="lastName">
                        <Form.Label>Last Name</Form.Label>
                        <Form.Control
                            type="text"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={6}>
                    <Form.Group controlId="birthDate">
                        <Form.Label>Date of Birth</Form.Label>
                        <Form.Control
                            type="date"
                            name="birthDate"
                            value={formData.birthDate.slice(0, 10)} // Format date for input
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group controlId="nationality">
                        <Form.Label>Nationality</Form.Label>
                        <Form.Control
                            type="text"
                            name="nationality"
                            value={formData.nationality}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={6}>
                    <Form.Group controlId="state">
                        <Form.Label>State</Form.Label>
                        <Form.Control
                            type="text"
                            name="state"
                            value={formData.state}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
                <Col xs={6}>
                    <Form.Group controlId="city">
                        <Form.Label>City</Form.Label>
                        <Form.Control
                            type="text"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={6}>
                    <Form.Group controlId="phone">
                        <Form.Label>Phone</Form.Label>
                        <Form.Control
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <Row className="mb-3">
                <Col xs={12}>
                    <Form.Group controlId="address">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                            type="text"
                            name="address"
                            value={formData.address}
                            onChange={handleChange}
                        />
                    </Form.Group>
                </Col>
            </Row>

            <div className="d-flex justify-content-end">
                <Button variant="secondary" onClick={onCancel} className="me-2">
                    Cancel
                </Button>
                <Button type="submit" className="greenButton">
                    Save Changes
                </Button>
            </div>
        </Form>
    );
};

export default ProfileEdit;